import { Component, computed, input, signal } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatError, MatFormField, MatInput } from '@angular/material/input';
import { MatPrefix, MatSuffix } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { FieldTree, FormField } from '@angular/forms/signals';
import { FormFieldWrapper } from '../../core/form/form-field-wrapper/form-field-wrapper';

@Component({
  selector: 'app-password-field',
  imports: [
    FormFieldWrapper,
    MatIconButton,
    MatError,
    MatFormField,
    MatInput,
    MatIcon,
    MatPrefix,
    MatSuffix,
    FormField,
  ],
  templateUrl: './password-field.html',
})
export class PasswordField {
  readonly label = input.required<string>();
  readonly field = input.required<FieldTree<string>>();
  readonly autocomplete = input.required<string>();
  readonly prefixIcon = input<string | null>(null);

  readonly show = signal(false);
  readonly state = computed(() => this.field()());
}
